/*eslint-disable */
import cacheLs from '../cacheLs'

export default {
  setApplicationStaticConfig (state, staticConfig) {
    cacheLs.set_application_static_config(staticConfig);
    state.applicationStaticConfig = staticConfig;
  },
  setActiveMicroApp (state, appName) {
    cacheLs.set_active_microapp(appName);
    state.activeMicroApp = appName;
  }
}
